define.alias("shared/errors/credentials", "settings/errors/credentials");